const ToolsSection = ({ tools = [] }) => {
    if (tools.length <=0 ) return null;
    return (
        <div className="tools">
            <h3>Tools</h3>
            <div className="tools__container">
                {
                    tools.map((tool, _index) => (
                        <div key={_index} className="tools__container__img">
                            <img className="pow" src={tool} alt="tools" />
                        </div>
                    ))
                }
            </div>

        </div>
    );
}

export default ToolsSection;